import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { UserApi, UserProfileModel } from 'mvppoker-portal-common/api'
import { useDispatch, useSelector } from 'react-redux'
import React, { useState } from 'react'
import { toast } from 'react-hot-toast'
import { createMVPModal } from '../../Modal'
import { useApi } from '../../../../utils/useApi'
import { FriendsTransferFundsModalView } from './FriendsTransferFundsModalView'
import { RootState } from '../../../../state/AppStore'
import { updateWallet } from '../../../../state/reducers/activeUser'

class FriendsTransferFundsModal
{
	Show(friend: UserProfileModel) 
	{
		NiceModal.show(createMVPModal('friends-transfer-funds-modal', () =>
		{
			const modal = useModal()
			const dispatch = useDispatch()
			const moneyAmount = useSelector((state: RootState) => state.activeUser.wallet?.amount)
			const [isLoading, setLoading] = useState(false)
			const api = useApi(UserApi)
		
			const clickSubmit = (amount: string) => {
				setLoading(true)
		
				api.usersWalletTransferToOtherUser(friend.userId, { value: amount })
				.then((wallet) => dispatch(updateWallet(wallet.data)))
				.then(() => {
					toast.success('Funds transferred!')
					modal.resolve()
					modal.hide()
				})
				.finally(() => {
					setLoading(false)
				})
				.catch((err) => {
					toast.error('An error occurred')
					modal.reject(err)
				})
			}
			const clickClose = () => {
				modal.hide()
			}

			return <FriendsTransferFundsModalView
				moneyAmount={moneyAmount ?? '0'} 
	
				isLoading={isLoading}
				clickSubmit={clickSubmit}
				clickClose={clickClose}
			/>
		}))
	}
}

const modal = new FriendsTransferFundsModal()
export default modal
